
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {certificatesModule, certificatesState} from '@/utils/store-acessor';
  import {CertificateModel} from '@/models/certificate.model';
  import CollaborationCertificate from '@/components/certificates/CollaborationCertificate.vue';

  @Component({
    components: {CollaborationCertificate}
  })
  export default class CertificateToPrint extends Vue {
    @certificatesModule.Getter('certificate') certificate!: CertificateModel;


    async mounted() {
      await certificatesState.findByVerifyCode(this.$route.params?.verifyCode);

      setTimeout(() => {
        print()
      }, 1000)
    }
  }
